import { buildSparklinePath } from "../lib/chart.js";

// Minimal SVG area/line sparkline for a portfolio value time series.
// No charting library — the repo has none, and this is simple enough
// not to need one. Colors are passed in so this stays independent of
// either shell's design-token object.
export default function ValueChart({ points, width = 320, height = 72, stroke = "#00D67E", fill = "rgba(0,214,126,0.14)" }) {
  const path = buildSparklinePath(points, { width, height });
  if (!path) return null;

  return (
    <svg width="100%" height={height} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" style={{ display: "block" }}>
      <path d={path.areaPath} fill={fill} stroke="none" />
      <path d={path.linePath} fill="none" stroke={stroke} strokeWidth={1.5} strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
